(ns common.widgets.navigation-bar
  (:require ["@mui/material/AppBar$default" :as Appbar]
            ["@mui/material/Avatar$default" :as Avatar]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/ListItemIcon$default" :as ListItemIcon]
            ["@mui/material/ListItemText$default" :as ListItemText]
            ["@mui/material/ListSubheader$default" :as ListSubheader]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Popper$default" :as Popper]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Toolbar$default" :as Toolbar]
            ["@mui/material/Typography$default" :as Typography]
            ["react" :as react]
            ["src/svg/editor/objects/text.svg$default" :as Text]
            ["src/svg/files_folders/file-new.svg$default" :as File]
            ["src/svg/location/map-marker.svg$default" :as MapMarker]
            ["src/svg/objects/database.svg$default" :as Database]
            ["src/svg/objects/movie.svg$default" :as Movie]
            ["src/svg/wpp/content/cart.svg$default" :as Cart]
            [clojure.string :as str]
            [common.url-template :as url-tpl]
            [common.util :as util]
            [common.widgets.logo :as logo]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn resolve-href
  [route url-context]
  (when route
    (or (r.easy/href route url-context)
        (r.easy/href :common/agency-selection))))

(defn user-name->initials [user-name]
  (->> (re-seq #"\w+" user-name)
       (map #(str/upper-case (first %)))
       (str/join)))

(defui user-avatar [{:keys [user-name]}]
  ($ Avatar
     {:sx #js {:bgcolor "primary.light"
               :fontSize "h3.fontSize"
               :width 32
               :height 32}}
     (when (seq user-name)
       (user-name->initials user-name))))

(defui account-menu []
  (let [{:keys [email] user-name :name} (use-subscribe [:resource.user/me])

        [anchor-el set-anchor-el] (uix/use-state nil)
        handle-click #(set-anchor-el (.. % -currentTarget))
        handle-close #(set-anchor-el nil)]
    ($ :<>
       ($ IconButton
          {:onClick handle-click
           :data-testid "account-button"}
          ($ user-avatar {:user-name user-name}))
       ($ Menu
          {:anchorEl anchor-el
           :open (some? anchor-el)
           :onClose handle-close
           :anchorOrigin #js {:vertical "bottom"
                              :horizontal "right"}
           :transformOrigin #js {:vertical "top"
                                 :horizontal "right"}}
          ($ MenuItem
             {:dense true
              :disabled true
              :sx #js {:textTransform "uppercase"
                       "&.Mui-disabled" #js {:opacity 1}}}
             "Account")
          ($ MenuItem
             {:disabled true
              :sx #js {"&.Mui-disabled" #js {:opacity 1}}}
             ($ ListItemIcon
                {:sx #js {:mr 1.5}}
                ($ user-avatar {:user-name user-name}))
             ($ ListItemText
                {:secondary email}
                user-name))
          ($ Divider)
          ($ MenuItem
             {:component "a"
              :href (r.easy/href :common/user {})
              :data-testid "profile-button"}
             ($ ListItemText "Profile"))
          ($ Divider)
          ($ MenuItem
             {:onClick #(rf/dispatch [:resource.auth/logout])
              :data-testid "logout-button"}
             ($ ListItemText "Log out"))))))

(def navigation-items
  [{:label "Campaigns"
    :route :advertiser/page}
   {:label "Libraries"
    :items [{:label "Media"
             :icon ($ SvgIcon {:inheritViewBox true} ($ Movie))
             :route :advertiser/assets}
            {:label "Templates"
             :icon ($ SvgIcon {:inheritViewBox true} ($ File))
             :route :advertiser/templates}
            {:label "Brand Guidelines"
             :icon ($ SvgIcon {:inheritViewBox true} ($ Text))
             :route :advertiser/brand-kit}
            {:label "Dynamic feeds"
             :icon ($ SvgIcon {:inheritViewBox true} ($ Database))
             :route :advertiser/feeds
             :permission "adsets2.view"}
            {:label "Products"
             :icon ($ SvgIcon {:inheritViewBox true} ($ Cart))
             :route :advertiser/products
             :permission "products.view"}
            {:label "POI"
             :icon ($ SvgIcon {:inheritViewBox true} ($ MapMarker))
             :route :advertiser/poi
             :flag :poi}]}
   {:label "Reports"
    :route :advertiser/reports}
   {:icon "more_horiz"
    :items [{:group "Product Help"
             :items [{:label "Support"
                      :target "_blank"
                      :template :docs/support}
                     {:label "Docs"
                      :target "_blank"
                      :template :docs/home}]}
            {:group "Admin"
             :items [{:label "Adservers"
                      :route :agency/configuration}
                     {:label "Advertiser"
                      :route :agency/advertiser-management}
                     {:label "Users & Roles"
                      :route :agency/user-management}
                     {:label "Delivery Insights"
                      :route :agency/delivery}
                     {:label "Social monitoring"
                      :route :advertiser/social-monitoring}]}]}])

(defui submenu-link [{:keys [icon label href template route target
                             flag permission url-context]}]
  (let [href (cond
               href href
               template (url-tpl/render template url-context)
               route (resolve-href route url-context))
        allowed-and-enabled? (use-subscribe [:router/allowed-and-enabled? {:flag flag :permissions permission}])]
    (when allowed-and-enabled?
      ($ MenuItem
         {:component "a"
          :href href
          :target target
          :sx #js {:borderRadius 1
                   :px 1
                   :py 0.5}}
         icon
         label))))

(defui submenu-group [{:keys [group items url-context]}]
  ($ :<>
     ($ Stack
        ($ ListSubheader
           {:sx #js {:fontSize "md"
                     :fontWeight "600"
                     :color "inherit"
                     :lineHeight 1.5
                     :px 1
                     :pt 1.5
                     :pb 0.5}}
           group)
        (for [[idx item] (mc/seq-indexed items)]
          ($ submenu-link (assoc item :key idx :url-context url-context))))
     ($ Divider
        {:sx #js {:my 0.5
                  "&:last-child" #js {:display "none"}}})))

(defui navigation-submenu [{:keys [items url-context children]}]
  (let [[open set-open] (uix/use-state false)
        anchor-ref (uix/use-ref)
        hover-timeout (uix/use-ref)

        handle-mouse-enter (fn []
                             (some-> @hover-timeout js/clearTimeout)
                             (set-open true))

        handle-mouse-leave (fn []
                             (reset! hover-timeout (js/setTimeout #(set-open false) 100)))]
    ($ :<>
       (-> (react/Children.only children)
           (react/cloneElement #js {:ref anchor-ref
                                    :onMouseEnter handle-mouse-enter
                                    :onMouseLeave handle-mouse-leave}))
       ($ Popper
          {:anchorEl @anchor-ref
           :open open
           :placement "bottom-start"
           :sx #js {:zIndex 800}}
          ($ Paper
             {:elevation 2
              :onMouseEnter handle-mouse-enter
              :onMouseLeave handle-mouse-leave
              :sx #js {:overflow "hidden"
                       :padding 1
                       :minWidth 200}}
             (for [[idx item] (mc/seq-indexed items)]
               (if (:group item)
                 ($ submenu-group (assoc item :key idx :url-context url-context))
                 ($ submenu-link (assoc item :key idx :url-context url-context)))))))))

(defui navigation-item [{:keys [route label icon items url-context]}]
  (let [active? (= route (use-subscribe [:router/handler-name]))
        component (cond
                    label ($ Button
                             {:href (resolve-href route url-context)
                              :component "a"
                              :sx (cond-> #js {:color "text.secondary"
                                               :whiteSpace "nowrap"
                                               :px 1
                                               :py 0.5
                                               :fontWeight "500"
                                               "&:hover" #js {:backgroundColor "grey.80"
                                                              :color "grey.100"}}
                                    active? (util/merge-objects
                                             #js {:color "grey.100"
                                                  :backgroundColor "grey.70"}))
                              :data-testid (some-> label
                                                   (str/replace #" " "-")
                                                   (str "-button")
                                                   (str/lower-case))
                              :endIcon (when (seq items)
                                         ($ Icon "expand_more"))}
                             label)
                    icon ($ IconButton
                            {:sx #js {:borderRadius 1}}
                            ($ Icon icon)))]
    (if (seq items)
      ($ navigation-submenu
         {:items items :url-context url-context}
         component)
      component)))

(defui navigation-bar [{:keys [sx]}]
  (let [common-os-disabled (use-subscribe [:common.os/disabled])
        last-viewed-agency-id (js/localStorage.getItem "last-viewed-agency-id")
        last-viewed-advertiser-id (js/localStorage.getItem "last-viewed-advertiser-id")
        url-context (merge {:agency-id last-viewed-agency-id
                            :advertiser-id last-viewed-advertiser-id}
                           (use-subscribe [:url-context]))]
    ($ Appbar
       {:sx #js {:position "relative"
                 :backgroundColor "background.paper"
                 :backgroundImage "none"
                 :borderBottomStyle "solid"
                 :borderBottomWidth "1px"
                 :borderBottomColor "divider"
                 :zIndex 700}}
       ($ Toolbar {:sx sx}
          ($ Stack
             {:direction "row"
              :gap 1.5
              :alignItems "center"
              :sx #js {:mr 4
                       :textDecoration "none"}
              :component "a"
              :href (resolve-href :advertiser/page url-context)
              :data-testid "create-logo"}
             ($ logo/activation-logo
                {:width 40
                 :height 40})
             ($ Typography
                {:fontSize "lg"
                 :fontWeight 600
                 :color "initial"}
                "Creative Optimizations"))

          ($ Stack {:direction "row"
                    :justifyContent "space-between"
                    :alignItems "center"
                    :sx #js {:flex 1}}
             ($ Stack
                {:direction "row"
                 :spacing 1}
                (for [[idx item] (mc/seq-indexed navigation-items)]
                  ($ navigation-item
                     (assoc item
                            :key idx
                            :url-context url-context))))
             (when common-os-disabled
               ($ account-menu)))))))
